import { Locale } from 'chaika-enums';
export const dictaphone = {
    dictaphoneResultsTitle: {
        [Locale.Ru]: 'Результаты обработки аудиозаписи',
        [Locale.Am]: 'Ձայնագրության մշակման արդյունքները',
        [Locale.En]: 'Audio processing results',
        [Locale.Pt]: 'Resultados do processamento do áudio',
        [Locale.Ge]: 'Audio processing results',
    },
    dictaphoneResultsHint: {
        [Locale.Ru]: 'Вы можете отредактировать результаты обработки в текстовых полях. Данные сохранятся автоматически. Добавляйте данные в запись по каждому полю отдельно или все целиком. Исключите данные, если не хотите, чтобы они попадали в запись. Не распознанное будет добавлено в заметки',
        [Locale.Am]: 'Դուք կարող եք խմբագրել մշակման արդյունքները տեքստային դաշտերում։ Տվյալները կպահպանվեն ավտոմատ։ Ավելացրեք տվյալները գրառման մեջ առանձին դաշտերով կամ ամբողջությամբ։ Բացառեք տվյալները, եթե չեք ցանկանում, որ դրանք հայտնվեն գրառման մեջ։ Չճանաչվածը կավելացվի նշումներին',
        [Locale.En]: 'You can edit the processing results in the text fields. Changes are saved automatically. Add data to the entry field by field or all at once. Exclude data you do not want in the entry. Unrecognized data goes to the notes',
        [Locale.Pt]: 'Você pode editar os resultados do processamento nos campos de texto. As alterações são salvas automaticamente. Adicione os dados à entrada campo a campo ou todos de uma vez. Exclua os dados que não deseja na entrada. O que não foi reconhecido vai para as notas',
        [Locale.Ge]: 'You can edit the processing results in the text fields. Changes are saved automatically. Add data to the entry field by field or all at once. Exclude data you do not want in the entry. Unrecognized data goes to the notes',
    },
    dictaphoneTabAssessment: {
        [Locale.Ru]: 'Оценка',
        [Locale.Am]: 'Գնահատում',
        [Locale.En]: 'Assessment',
        [Locale.Pt]: 'Avaliação',
        [Locale.Ge]: 'Assessment',
    },
    dictaphoneTabPlan: {
        [Locale.Ru]: 'План',
        [Locale.Am]: 'Պլան',
        [Locale.En]: 'Plan',
        [Locale.Pt]: 'Plano',
        [Locale.Ge]: 'Plan',
    },
    dictaphoneTabUnrecognized: {
        [Locale.Ru]: 'Не распознанное',
        [Locale.Am]: 'Չճանաչված',
        [Locale.En]: 'Unrecognized',
        [Locale.Pt]: 'Não reconhecido',
        [Locale.Ge]: 'Unrecognized',
    },
    dictaphoneEpisodeDiagnosesHint: {
        [Locale.Ru]: 'Отредактировать информацию по диагнозам эпизодов можно будет после добавления в запись',
        [Locale.Am]: 'Էպիզոդների ախտորոշումների տվյալները հնարավոր կլինի խմբագրել գրառմանն ավելացնելուց հետո',
        [Locale.En]: 'Episode diagnoses can be edited after they are added to the entry',
        [Locale.Pt]: 'Os diagnósticos do episódio poderão ser editados após serem adicionados à entrada',
        [Locale.Ge]: 'Episode diagnoses can be edited after they are added to the entry',
    },
    dictaphoneEpisodeWillBeCreated: {
        [Locale.Ru]: 'Будет создан эпизод',
        [Locale.Am]: 'Կստեղծվի էպիզոդ',
        [Locale.En]: 'A new episode will be created',
        [Locale.Pt]: 'Um novo episódio será criado',
        [Locale.Ge]: 'A new episode will be created',
    },
    dictaphoneEpisodeWillBeAttached: {
        [Locale.Ru]: 'Запись будет добавлена в существующий эпизод',
        [Locale.Am]: 'Գրառումը կավելացվի գոյություն ունեցող էպիզոդում',
        [Locale.En]: 'The entry will be attached to an existing episode',
        [Locale.Pt]: 'A entrada será anexada a um episódio existente',
        [Locale.Ge]: 'The entry will be attached to an existing episode',
    },
    dictaphoneAddAllResults: {
        [Locale.Ru]: 'Добавить все результаты в запись',
        [Locale.Am]: 'Ավելացնել բոլոր արդյունքները գրառմանը',
        [Locale.En]: 'Add all results to the entry',
        [Locale.Pt]: 'Adicionar todos os resultados à entrada',
        [Locale.Ge]: 'Add all results to the entry',
    },
    dictaphoneExcludeItem: {
        [Locale.Ru]: 'Исключить',
        [Locale.Am]: 'Բացառել',
        [Locale.En]: 'Exclude',
        [Locale.Pt]: 'Excluir',
        [Locale.Ge]: 'Exclude',
    },
    dictaphoneItemAdded: {
        [Locale.Ru]: 'Добавлено в запись',
        [Locale.Am]: 'Ավելացված է գրառմանը',
        [Locale.En]: 'Added to the entry',
        [Locale.Pt]: 'Adicionado à entrada',
        [Locale.Ge]: 'Added to the entry',
    },
    dictaphoneEpisodeSelectPlaceholder: {
        [Locale.Ru]: 'Выбрать эпизоды или ввести название нового',
        [Locale.Am]: 'Ընտրել էպիզոդներ կամ մուտքագրել նորի անվանումը',
        [Locale.En]: 'Choose episodes or type a new name',
        [Locale.Pt]: 'Escolha episódios ou digite um novo nome',
        [Locale.Ge]: 'Choose episodes or type a new name',
    },
    dictaphoneEpisodeSelectHint: {
        [Locale.Ru]: 'Выберите открытые эпизоды пациента или создайте новый',
        [Locale.Am]: 'Ընտրեք պացիենտի բաց էպիզոդները կամ ստեղծեք նորը',
        [Locale.En]: 'Choose open episodes of the patient or create a new one',
        [Locale.Pt]: 'Escolha episódios abertos do paciente ou crie um novo',
        [Locale.Ge]: 'Choose open episodes of the patient or create a new one',
    },
    dictaphoneEpisodeAttachedToEntry: {
        [Locale.Ru]: 'Эпизод в записи',
        [Locale.Am]: 'Էպիզոդը գրառման մեջ է',
        [Locale.En]: 'Episode in the entry',
        [Locale.Pt]: 'Episódio na entrada',
        [Locale.Ge]: 'Episode in the entry',
    },
    dictaphoneItemExcluded: {
        [Locale.Ru]: 'Эти данные не будут добавлены в запись',
        [Locale.Am]: 'Այս տվյալները չեն ավելացվի գրառմանը',
        [Locale.En]: 'This data will not be added to the entry',
        [Locale.Pt]: 'Estes dados não serão adicionados à entrada',
        [Locale.Ge]: 'This data will not be added to the entry',
    },
    dictaphoneItemRequiresEpisode: {
        [Locale.Ru]: 'У записи нет открытого эпизода. Сначала добавьте его',
        [Locale.Am]: 'Գրառումը բաց էպիզոդ չունի։ Նախ ավելացրեք այն',
        [Locale.En]: 'The entry has no open episode. Add one first',
        [Locale.Pt]: 'A entrada não tem um episódio aberto. Adicione um primeiro',
        [Locale.Ge]: 'The entry has no open episode. Add one first',
    },
    dictaphoneUpdateItemText: {
        [Locale.Ru]: 'Обновить данные',
        [Locale.Am]: 'Թարմացնել տվյալները',
        [Locale.En]: 'Update data',
        [Locale.Pt]: 'Atualizar dados',
        [Locale.Ge]: 'Update data',
    },
    dictaphoneItemUpdated: {
        [Locale.Ru]: 'Обновлено',
        [Locale.Am]: 'Թարմացված է',
        [Locale.En]: 'Updated',
        [Locale.Pt]: 'Atualizado',
        [Locale.Ge]: 'Updated',
    },
    dictaphoneItemChangedInEntry: {
        [Locale.Ru]: 'Поле изменено в записи, отредактируйте его там',
        [Locale.Am]: 'Դաշտը փոխվել է գրառման մեջ, խմբագրեք այն այնտեղ',
        [Locale.En]: 'The field was changed in the entry, edit it there',
        [Locale.Pt]: 'O campo foi alterado na entrada, edite-o lá',
        [Locale.Ge]: 'The field was changed in the entry, edit it there',
    },
    dictaphoneAddAllWithoutEpisodeTitle: {
        [Locale.Ru]: 'Не все объекты будут добавлены в запись',
        [Locale.Am]: 'Ոչ բոլոր օբյեկտները կավելացվեն գրառմանը',
        [Locale.En]: 'Not all items will be added to the entry',
        [Locale.Pt]: 'Nem todos os itens serão adicionados à entrada',
        [Locale.Ge]: 'Not all items will be added to the entry',
    },
    dictaphoneAddAllWithoutEpisodeMessage: {
        [Locale.Ru]: 'Эпизод из расшифровки исключён, поэтому некоторые объекты будут добавлены только в заметки. Верните эпизод, тогда объекты будут созданы на своих местах',
        [Locale.Am]: 'Վերծանման էպիզոդը բացառված է, ուստի որոշ օբյեկտներ կավելացվեն միայն նշումներում։ Վերադարձրեք էպիզոդը, և օբյեկտները կստեղծվեն իրենց տեղերում',
        [Locale.En]: 'The episode from the transcription is excluded, so some items will only be added to the notes. Return the episode and the items will be created in their places',
        [Locale.Pt]: 'O episódio da transcrição foi excluído, por isso alguns itens serão adicionados apenas às notas. Devolva o episódio e os itens serão criados nos seus lugares',
        [Locale.Ge]: 'The episode from the transcription is excluded, so some items will only be added to the notes. Return the episode and the items will be created in their places',
    },
    dictaphoneAddAllNoOpenEpisodeMessage: {
        [Locale.Ru]: 'У записи нет открытого эпизода, поэтому некоторые объекты будут добавлены только в заметки. Чтобы этого избежать, добавьте эпизод',
        [Locale.Am]: 'Գրառումը բաց էպիզոդ չունի, ուստի որոշ օբյեկտներ կավելացվեն միայն նշումներում։ Դրանից խուսափելու համար ավելացրեք էպիզոդ',
        [Locale.En]: 'The entry has no open episode, so some items will only be added to the notes. To avoid this, add an episode',
        [Locale.Pt]: 'A entrada não tem nenhum episódio aberto, por isso alguns itens serão adicionados apenas às notas. Para evitar isso, adicione um episódio',
        [Locale.Ge]: 'ჩანაწერს ღია ეპიზოდი არ აქვს, ამიტომ ზოგიერთი ობიექტი მხოლოდ შენიშვნებში დაემატება. ამის თავიდან ასაცილებლად დაამატეთ ეპიზოდი',
    },
    dictaphoneAddAllToNote: {
        [Locale.Ru]: 'Добавить в заметку',
        [Locale.Am]: 'Ավելացնել նշումներում',
        [Locale.En]: 'Add to the note',
        [Locale.Pt]: 'Adicionar à nota',
        [Locale.Ge]: 'Add to the note',
    },
    dictaphoneBackToTranscription: {
        [Locale.Ru]: 'Вернуться к расшифровке',
        [Locale.Am]: 'Վերադառնալ վերծանմանը',
        [Locale.En]: 'Back to the transcription',
        [Locale.Pt]: 'Voltar à transcrição',
        [Locale.Ge]: 'Back to the transcription',
    },
    dictaphoneEmptyTranscription: {
        [Locale.Ru]: 'В расшифровке нет текста для добавления.',
        [Locale.Am]: 'Վերծանման մեջ ավելացնելու տեքստ չկա։',
        [Locale.En]: 'Transcription has no content to add.',
        [Locale.Pt]: 'A transcrição não tem conteúdo a adicionar.',
        [Locale.Ge]: 'Transcription has no content to add.',
    },
    dictaphoneFollowUpTasks: {
        [Locale.Ru]: 'Задания и контрольные явки',
        [Locale.Am]: 'Առաջադրանքներ և հսկիչ այցեր',
        [Locale.En]: 'Follow-up tasks',
        [Locale.Pt]: 'Tarefas de acompanhamento',
        [Locale.Ge]: 'Follow-up tasks',
    },
    dictaphoneDrugs: {
        [Locale.Ru]: 'Медикаменты',
        [Locale.Am]: 'Դեղամիջոցներ',
        [Locale.En]: 'Medications',
        [Locale.Pt]: 'Medicamentos',
        [Locale.Ge]: 'Medications',
    },
    dictaphoneTooShortRecordingTitle: {
        [Locale.Ru]: 'Запись слишком короткая',
        [Locale.Am]: 'Ձայնագրությունը չափազանց կարճ է',
        [Locale.En]: 'Recording is too short',
        [Locale.Pt]: 'A gravação é muito curta',
        [Locale.Ge]: 'Recording is too short',
    },
    dictaphoneTooShortRecordingMessage: {
        [Locale.Ru]: 'Длительность записи $seconds сек. Расшифровка возможна только для записей длиннее $min сек.',
        [Locale.Am]: 'Ձայնագրության տևողությունը $seconds վրկ։ Վերծանումը հնարավոր է միայն $min վրկ-ից երկար ձայնագրությունների համար։',
        [Locale.En]: 'Recording length is $seconds s. Transcription requires at least $min s.',
        [Locale.Pt]: 'A duração da gravação é $seconds s. A transcrição requer pelo menos $min s.',
        [Locale.Ge]: 'Recording length is $seconds s. Transcription requires at least $min s.',
    },
    dictaphoneEmptyRecordingTitle: {
        [Locale.Ru]: 'Запись не сохранилась',
        [Locale.Am]: 'Ձայնագրությունը չի պահպանվել',
        [Locale.En]: 'Recording was not saved',
        [Locale.Pt]: 'A gravação não foi salva',
        [Locale.Ge]: 'Recording was not saved',
    },
    dictaphoneEmptyRecordingMessage: {
        [Locale.Ru]: 'Аудиофайл пуст — запись могла прерваться из-за перезагрузки или закрытия страницы. Расшифровка невозможна, удалите запись и создайте новую.',
        [Locale.Am]: 'Աուդիոֆայլը դատարկ է — ձայնագրությունը կարող էր ընդհատվել էջի վերաբեռնման կամ փակման պատճառով։ Վերծանումն անհնար է, ջնջեք ձայնագրությունը և ստեղծեք նորը։',
        [Locale.En]: 'The audio file is empty — the recording may have been interrupted by a page reload or close. Transcription is not possible, delete the recording and create a new one.',
        [Locale.Pt]: 'O arquivo de áudio está vazio — a gravação pode ter sido interrompida por recarregamento ou fechamento da página. A transcrição não é possível, exclua a gravação e crie uma nova.',
        [Locale.Ge]: 'The audio file is empty — the recording may have been interrupted by a page reload or close. Transcription is not possible, delete the recording and create a new one.',
    },
    dictaphoneStorageErrorTitle: {
        [Locale.Ru]: 'Запись остановлена',
        [Locale.Am]: 'Ձայնագրությունը դադարեցված է',
        [Locale.En]: 'Recording stopped',
        [Locale.Pt]: 'Gravação interrompida',
        [Locale.Ge]: 'Recording stopped',
    },
    dictaphoneStorageErrorMessage: {
        [Locale.Ru]: 'Не удалось сохранить аудио на диск. Записанная часть сохранена — её можно расшифровать или продолжить запись.',
        [Locale.Am]: 'Չհաջողվեց պահպանել աուդիոն սկավառակում։ Ձայնագրված մասը պահպանվել է — այն կարելի է վերծանել կամ շարունակել ձայնագրությունը։',
        [Locale.En]: 'Failed to save audio to disk. The recorded part has been saved — you can transcribe it or resume recording.',
        [Locale.Pt]: 'Falha ao salvar o áudio no disco. A parte gravada foi salva — você pode transcrevê-la ou retomar a gravação.',
        [Locale.Ge]: 'Failed to save audio to disk. The recorded part has been saved — you can transcribe it or resume recording.',
    },
    dictaphoneSilenceWarningTitle: {
        [Locale.Ru]: 'Звук не распознан',
        [Locale.Am]: 'Ձայնը չի ճանաչվել',
        [Locale.En]: 'No sound detected',
        [Locale.Pt]: 'Nenhum som detectado',
        [Locale.Ge]: 'No sound detected',
    },
    dictaphoneSilenceWarningMessage: {
        [Locale.Ru]: 'Последнюю минуту запись идёт, но звука нет. Проверьте, что микрофон включён и выбран правильный.',
        [Locale.Am]: 'Վերջին րոպեին ձայնագրությունն ընթանում է, սակայն ձայն չկա։ Ստուգեք, որ խոսափողը միացված է և ընտրված է ճիշտը։',
        [Locale.En]: 'Recording is running, but no sound has been detected for the last minute. Check that the microphone is on and the right one is selected.',
        [Locale.Pt]: 'A gravação está em andamento, mas nenhum som foi detectado no último minuto. Verifique se o microfone está ligado e se o correto está selecionado.',
        [Locale.Ge]: 'Recording is running, but no sound has been detected for the last minute. Check that the microphone is on and the right one is selected.',
    },
    dictaphoneDeleteRecordConfirm: {
        [Locale.Ru]: 'Аудиозапись и результаты её обработки будут удалены. Уже добавленные в запись данные останутся.',
        [Locale.Am]: 'Ձայնագրությունը և դրա մշակման արդյունքները կջնջվեն։ Գրառմանն արդեն ավելացված տվյալները կպահպանվեն։',
        [Locale.En]: 'The audio recording and its processing results will be deleted. Data already added to the entry stays.',
        [Locale.Pt]: 'A gravação de áudio e os resultados do processamento serão eliminados. Os dados já adicionados à entrada permanecem.',
        [Locale.Ge]: 'The audio recording and its processing results will be deleted. Data already added to the entry stays.',
    },
    dictaphoneDeletePausedRecordConfirm: {
        [Locale.Ru]: 'Незавершённая аудиозапись будет удалена.',
        [Locale.Am]: 'Անավարտ ձայնագրությունը կջնջվի։',
        [Locale.En]: 'The unfinished audio recording will be deleted.',
        [Locale.Pt]: 'A gravação de áudio inacabada será eliminada.',
        [Locale.Ge]: 'The unfinished audio recording will be deleted.',
    },
    dictaphoneStartNewRecordConfirm: {
        [Locale.Ru]: 'Текущая аудиозапись и результаты её обработки будут удалены. Начать новую запись?',
        [Locale.Am]: 'Ընթացիկ ձայնագրությունը և դրա մշակման արդյունքները կջնջվեն։ Սկսե՞լ նոր ձայնագրություն։',
        [Locale.En]: 'The current audio recording and its processing results will be deleted. Start a new recording?',
        [Locale.Pt]: 'A gravação de áudio atual e os resultados do processamento serão eliminados. Iniciar uma nova gravação?',
        [Locale.Ge]: 'The current audio recording and its processing results will be deleted. Start a new recording?',
    },
    dictaphoneMostlySilentConfirm: {
        [Locale.Ru]: 'Запись почти полностью тихая — возможно, микрофон не работал. Отправить её на расшифровку?',
        [Locale.Am]: 'Ձայնագրությունը գրեթե ամբողջովին լուռ է — հնարավոր է՝ խոսափողը չի աշխատել։ Ուղարկե՞լ այն վերծանման',
        [Locale.En]: 'The recording is almost completely silent — the microphone may not have been working. Send it for transcription anyway?',
        [Locale.Pt]: 'A gravação está quase completamente silenciosa — o microfone pode não ter funcionado. Enviar para transcrição mesmo assim?',
        [Locale.Ge]: 'The recording is almost completely silent — the microphone may not have been working. Send it for transcription anyway?',
    },
    dictaphoneMicrophonePermissionHint: {
        [Locale.Ru]: 'Разрешите запись голоса в настройках браузера. Переключатель у микрофона должен быть включен.',
        [Locale.Am]: 'Թույլատրեք ձայնագրումը բրաուզերի կարգավորումներում։ Խոսափողի անջատիչը պետք է միացված լինի։',
        [Locale.En]: 'Allow voice recording in your browser settings. The microphone toggle must be turned on.',
        [Locale.Pt]: 'Permita a gravação de voz nas configurações do navegador. O botão do microfone deve estar ativado.',
        [Locale.Ge]: 'Allow voice recording in your browser settings. The microphone toggle must be turned on.',
    },
    dictaphoneUploadingRecord: {
        [Locale.Ru]: 'Загрузка аудиозаписи',
        [Locale.Am]: 'Ձայնագրության վերբեռնում',
        [Locale.En]: 'Uploading the audio record',
        [Locale.Pt]: 'Carregando a gravação',
        [Locale.Ge]: 'აუდიოჩანაწერის ატვირთვა',
    },
    dictaphoneSubmittingForTranscription: {
        [Locale.Ru]: 'Отправка записи на расшифровку',
        [Locale.Am]: 'Ձայնագրության ուղարկում վերծանման',
        [Locale.En]: 'Sending the record for transcription',
        [Locale.Pt]: 'Enviando a gravação para transcrição',
        [Locale.Ge]: 'ჩანაწერის გაგზავნა გაშიფვრისთვის',
    },
    dictaphoneTranscribingRecord: {
        [Locale.Ru]: 'Расшифровка аудиозаписи',
        [Locale.Am]: 'Ձայնագրության վերծանում',
        [Locale.En]: 'Transcribing the audio record',
        [Locale.Pt]: 'Transcrevendo a gravação',
        [Locale.Ge]: 'აუდიოჩანაწერის გაშიფვრა',
    },
    dictaphoneProcessingRecord: {
        [Locale.Ru]: 'Обработка аудиозаписи',
        [Locale.Am]: 'Ձայնագրության մշակում',
        [Locale.En]: 'Processing the audio record',
        [Locale.Pt]: 'Processando a gravação',
        [Locale.Ge]: 'აუდიოჩანაწერის დამუშავება',
    },
    dictaphoneProcessedTitle: {
        [Locale.Ru]: 'Аудиозапись обработана!',
        [Locale.Am]: 'Ձայնագրությունը մշակված է։',
        [Locale.En]: 'The audio record is processed!',
        [Locale.Pt]: 'A gravação foi processada!',
        [Locale.Ge]: 'აუდიოჩანაწერი დამუშავებულია!',
    },
    dictaphoneProcessedHint: {
        [Locale.Ru]: 'Вы можете посмотреть результаты и отредактировать их',
        [Locale.Am]: 'Կարող եք դիտել արդյունքները և խմբագրել դրանք',
        [Locale.En]: 'You can review the results and edit them',
        [Locale.Pt]: 'Você pode ver os resultados e editá-los',
        [Locale.Ge]: 'შეგიძლიათ ნახოთ შედეგები და დაარედაქტიროთ',
    },
    dictaphoneShowResults: {
        [Locale.Ru]: 'Посмотреть',
        [Locale.Am]: 'Դիտել',
        [Locale.En]: 'Review',
        [Locale.Pt]: 'Ver',
        [Locale.Ge]: 'ნახვა',
    },
    dictaphoneShowProcessingResults: {
        [Locale.Ru]: 'Показать результаты обработки',
        [Locale.Am]: 'Ցույց տալ մշակման արդյունքները',
        [Locale.En]: 'Show processing results',
        [Locale.Pt]: 'Mostrar resultados do processamento',
        [Locale.Ge]: 'დამუშავების შედეგების ჩვენება',
    },
    dictaphoneAddDataLater: {
        [Locale.Ru]: 'Позже',
        [Locale.Am]: 'Ավելի ուշ',
        [Locale.En]: 'Later',
        [Locale.Pt]: 'Mais tarde',
        [Locale.Ge]: 'მოგვიანებით',
    },
    dictaphoneMicrophoneDeniedError: {
        [Locale.Ru]: 'Доступ к микрофону запрещён',
        [Locale.Am]: 'Խոսափողի հասանելիությունն արգելված է',
        [Locale.En]: 'Microphone access is blocked',
        [Locale.Pt]: 'O acesso ao microfone está bloqueado',
        [Locale.Ge]: 'მიკროფონზე წვდომა აკრძალულია',
    },
    dictaphonePermissionsApiUnsupportedError: {
        [Locale.Ru]: 'Ваш браузер не поддерживает Permissions API',
        [Locale.Am]: 'Ձեր բրաուզերը չի աջակցում Permissions API-ին',
        [Locale.En]: 'Your browser does not support the Permissions API',
        [Locale.Pt]: 'O seu navegador não suporta a Permissions API',
        [Locale.Ge]: 'თქვენი ბრაუზერი არ უჭერს მხარს Permissions API-ს',
    },
    dictaphoneRecordingInProgressTitle: {
        [Locale.Ru]: 'Ведётся аудиозапись',
        [Locale.Am]: 'Ընթանում է աուդիոձայնագրում',
        [Locale.En]: 'Audio recording in progress',
        [Locale.Pt]: 'Gravação de áudio em andamento',
        [Locale.Ge]: 'მიმდინარეობს აუდიოჩაწერა',
    },
    dictaphoneLeaveWhileRecordingDescription: {
        [Locale.Ru]: 'Если продолжить, аудиозапись будет направлена на расшифровку. Результаты обработки будут доступны на странице записи',
        [Locale.Am]: 'Եթե շարունակեք, աուդիոձայնագրությունը կուղարկվի վերծանման։ Մշակման արդյունքները հասանելի կլինեն գրառման էջում',
        [Locale.En]: 'If you continue, the recording will be sent for transcription. The results will be available on the entry page',
        [Locale.Pt]: 'Se continuar, a gravação será enviada para transcrição. Os resultados estarão disponíveis na página do registro',
        [Locale.Ge]: 'თუ გააგრძელებთ, აუდიოჩანაწერი გაიგზავნება ტრანსკრიფციაზე. შედეგები ხელმისაწვდომი იქნება ჩანაწერის გვერდზე',
    },
    dictaphoneSignWhileRecordingDescription: {
        [Locale.Ru]: 'Если продолжить, аудиозапись будет отменена, расшифровки не будет',
        [Locale.Am]: 'Եթե շարունակեք, աուդիոձայնագրությունը կչեղարկվի, վերծանում չի լինի',
        [Locale.En]: 'If you continue, the recording will be cancelled and there will be no transcription',
        [Locale.Pt]: 'Se continuar, a gravação será cancelada e não haverá transcrição',
        [Locale.Ge]: 'თუ გააგრძელებთ, აუდიოჩანაწერი გაუქმდება და ტრანსკრიფცია არ იქნება',
    },
    dictaphoneUnprocessedRecordingTitle: {
        [Locale.Ru]: 'Аудиозапись не добавлена в запись',
        [Locale.Am]: 'Աուդիոձայնագրությունը գրառմանը ավելացված չէ',
        [Locale.En]: 'The recording has not been added to the entry',
        [Locale.Pt]: 'A gravação não foi adicionada ao registro',
        [Locale.Ge]: 'აუდიოჩანაწერი ჩანაწერს არ დაემატა',
    },
    dictaphoneUnprocessedRecordingDescription: {
        [Locale.Ru]: 'Аудиозапись сохранится и останется доступна на странице записи',
        [Locale.Am]: 'Աուդիոձայնագրությունը կպահպանվի և հասանելի կմնա գրառման էջում',
        [Locale.En]: 'The recording will be kept and stay available on the entry page',
        [Locale.Pt]: 'A gravação será mantida e continuará disponível na página do registro',
        [Locale.Ge]: 'აუდიოჩანაწერი შეინახება და ხელმისაწვდომი დარჩება ჩანაწერის გვერდზე',
    },
};
